<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M8 3.3335V12.6668" stroke="#184495" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.33331 8L12.6666 8" stroke="#184495" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconPlusBlue',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
